export default __webpack_public_path__ + "static/media/avatar-defaul-boy.60b92e78.jpg";